import { Box, FormHelperText, IconButton, Input, InputAdornment } from '@material-ui/core';
import { Lock, Visibility, VisibilityOff } from '@material-ui/icons';
import clsx from 'clsx';
import React, { Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import style from './AccountInput.scss';

interface Props {
  inputState: [string, Dispatch<SetStateAction<string>>];
  maskInputState?: Nullable<[boolean, Dispatch<SetStateAction<boolean>>]>;
  placeholder?: string; //external component does not support nullable types, so we can't apply Nullable<> type here
  disabled?: boolean; //external component does not support nullable types, so we can't apply Nullable<> type here
  includeValidation?: Nullable<boolean>;
  validationMessage?: Nullable<string>;
  cssClass?: Nullable<string>;
  onChange?: (value: string) => void;
}

export const AccountInput: React.FC<Props> = ({ inputState, maskInputState, placeholder, disabled, includeValidation, validationMessage, cssClass, onChange }) => {
  const addAdornment = useMemo(
    (): JSX.Element =>
      disabled ? (
        <InputAdornment position="end">
          <IconButton disabled>
            <Lock />
          </IconButton>
        </InputAdornment>
      ) : maskInputState ? (
        <InputAdornment position="end">
          <IconButton onClick={() => maskInputState[1](!maskInputState[0])}>{maskInputState[0] ? <VisibilityOff /> : <Visibility />}</IconButton>
        </InputAdornment>
      ) : (
        <React.Fragment />
      ),
    [disabled, maskInputState]
  );

  const inputProps = useMemo(() => ({ className: style.innerInputField }), []);
  const handleChange = useCallback(
    (e) => {
      onChange?.(e.target.value);
      inputState[1](e.target.value);
    },
    [inputState]
  );

  return (
    <React.Fragment>
      <Input
        placeholder={placeholder}
        disabled={disabled}
        type={!maskInputState?.[0] ? 'text' : 'password'}
        value={inputState[0]}
        className={clsx(style.inputField, cssClass)}
        autoComplete={maskInputState ? 'new-password' : undefined}
        inputProps={inputProps}
        onChange={handleChange}
        endAdornment={addAdornment}
      />
      {!!includeValidation && (
        <Box className={style.helperBox}>
          <FormHelperText hidden={!validationMessage} error>
            {validationMessage}
          </FormHelperText>
        </Box>
      )}
    </React.Fragment>
  );
};
